// Analytics utility for VSR Insurance Plus
// Supports Google Analytics 4 (via gtag), PostHog, and custom event logging.

export const initGA = () => {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaId || typeof window === 'undefined') return;

  // Prevent duplicate script injection
  if (document.getElementById('ga-gtag-script')) return;

  const script = document.createElement('script');
  script.id = 'ga-gtag-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', gaId, {
    send_page_view: true,
  });
};

export const trackPageView = (path, title) => {
  if (typeof window === 'undefined') return;

  // Track in Google Analytics 4
  if (window.gtag && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
    });
  }

  // Track in PostHog if available
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: path,
      title: title || document.title,
    });
  }
};

export const trackEvent = (action, params = {}) => {
  if (typeof window === 'undefined') return;

  // Google Analytics 4 event
  if (window.gtag) {
    window.gtag('event', action, params);
  }

  // PostHog event
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(action, params);
  }
};

export const trackWhatsAppClick = (locationName, details = {}) => {
  trackEvent('whatsapp_click', {
    location: locationName,
    advisor: 'V. S. Reddy',
    ...details,
  });
};

export const trackPhoneClick = (locationName) => {
  trackEvent('phone_call_click', {
    location: locationName,
    number: '+919849664800',
  });
};

export const trackConsultationSubmit = (formName, category) => {
  trackEvent('consultation_submit', {
    form_name: formName,
    category: category || 'general',
  });
};

// ==========================================
// NRI Lead Generation GA4 Conversion Events
// (Strictly NO PII passed to analytics)
// ==========================================

export const trackCallbackClick = (sourceLocation) => {
  trackEvent('callback_click', {
    source_location: sourceLocation || 'nri_blog',
    advisor: 'V. S. Reddy',
  });
};

export const trackCallbackFormStart = (formType) => {
  trackEvent('callback_form_start', {
    form_type: formType || 'embedded',
  });
};

export const trackLeadGenerated = (interestCategory, countryOfResidence) => {
  trackEvent('generate_lead', {
    currency: 'INR',
    insurance_interest: interestCategory || 'Unspecified',
    country_of_residence: countryOfResidence || 'Unspecified',
    value: 1.0,
  });
};
